import React from "react";

const SET_EXPORT_TYPE = "locale/visitors/SET_EXPORT_TYPE";

export const setExportType = (entityType, scope) => ({
    type: SET_EXPORT_TYPE,
    entityType: entityType,
    scope: scope,
})

export const initialState = {
    exportEntityType: false,
    exportScope: false,
};

export const LocalReducer = (state = initialState, action) => {
    switch (action.type) {

        case SET_EXPORT_TYPE: {
            return {
                ...state,
                exportEntityType: action.entityType,
                exportScope: action.scope
            }
        }

        default:
            return state;
    }
}
